import { AdditionalInterestType } from "@covertree/new-business-graphql";
import { mapAdditionalInterestTypeToLabel } from "@covertree/new-business-mappings";

export const interestTypeOptions: Array<{
  label: string;
  value: AdditionalInterestType;
}> = [
  AdditionalInterestType.Lienholder,
  AdditionalInterestType.HomeownersAssociation,
  AdditionalInterestType.GovernmentMunicipality,
  AdditionalInterestType.PropertyManagerParkOwner,
  AdditionalInterestType.NotListed,
].map((value) => ({ label: mapAdditionalInterestTypeToLabel(value), value }));

/** A tenant has no mortgage, so no lender can hold a lien on the home. */
export const getInterestTypeOptions = (isTenantPolicy?: boolean) =>
  isTenantPolicy
    ? interestTypeOptions.filter(
        (option) => option.value !== AdditionalInterestType.Lienholder
      )
    : interestTypeOptions;

/** How many interests of each type one policy may hold. */
export const defaultMaxInterests: Record<AdditionalInterestType, number> = {
  [AdditionalInterestType.Lienholder]: 2,
  [AdditionalInterestType.HomeownersAssociation]: 1,
  [AdditionalInterestType.GovernmentMunicipality]: 2,
  [AdditionalInterestType.PropertyManagerParkOwner]: 2,
  [AdditionalInterestType.NotListed]: 2,
};
